import spinner from '../../../../assets/lottie/spinner.svg';


export const SmallLoading = () => {
    return (
        <img src={spinner}
            style={{ margin: '0 auto', display: 'block' }}
        />
    );
}

export const TinyLoading = ({ size = '75px' }) => {
    return (
        <img src={spinner}
            style={{ height: size, width: size }}
        />
    );
}

export const MicroLoading = ({ size = '35px' }) => {
    return (
        <img src={spinner}
            style={{ height: size, width: size }}
        />
    );
}